module.exports = __webpack_public_path__ + "assets/ic_google.8de0ce4d.svg";